<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card style="height: calc(100vh - 40%); overflow: hidden;">
                    <div
                        ref="ganttContainer"
                        class="gantt-container"
                        style="width: 100%; height: 100%; max-height: 100%; overflow: hidden;"
                    />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import get from 'lodash/get';
import gantt from 'dhtmlx-gantt/codebase/dhtmlxgantt.js'
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'

export default {
  name: 'BookV2',
  data() {
    return {
      gantt: null,
      assetTypes: [],
      assets: [],
      vehicles: [],
      geofences: [],
      users: [],
    }
  },
  mounted() {
    Promise.all([
      this.getGeofences(),
      this.getAssetTypes(),
      this.getAssets(),
      this.getVehicles(),
      this.getUsers(),
    ]).then(() => {
        this.$nextTick(() => {
            this.initGantt();
        });
    });
  },
  beforeDestroy() {
    if (this.gantt) {
      this.gantt.destructor();
    }
  },
  computed: {
    clientid() {
      return this.$store.state.clientid;
    },
    user() {
        return this.$store.state.user.user;
    },
    isSuperAdmin() {
        return parseInt(this.user.type) == 3;
    },
    isAdmin() {
        return parseInt(this.user.type) == 1;
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() { 
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
    isWollongong() {
      return this.$store.state.clientid == 'A506MF91OINZ';
    },
    isYarra() {
      return this.$store.state.clientid === "HCQSWYNLHF6A";
    },
    isVictrack() {
      return this.$store.state.clientid === "E4IKWG0LDBM8";
    },
    isDarwin() {
      return this.$store.state.clientid === "ED73T6OILP78";
    },
    origins() {
        if (this.geofences[this.clientid]) {
        const groups = this.geofences[this.clientid].filter(
          group =>
            group.name === "Carpool Origin" ||
            group.name === "Carpool Origin - Destination" ||
            group.name === "Carpool Origin without Key Cabinet"
        );
        const geofences = [];
        groups.forEach((group, i) => {
          group.geofences.forEach((geofence, i) => {
            geofences.push(geofence);
          });
        });
        return geofences.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        }
        return [];
    }
  },
  methods: {
    getGeofences() {
        const payload = {};
        payload.clientid = this.clientid;
        if (this.isIntimap || this.isWSP) {
            payload.timezone = 1;
        }
        this.$store.dispatch("API_CALL", {
          $method: "get_geofences",
          $postData: payload,
        })
        .then((response) => {
          this.geofences = get(response, 'data.data', []);
        });
    },
    getVehicles() {
      this.$store.dispatch("API_CALL", {
        $method: "get_vehicles",
        $postData: {
          clientid: this.clientid,
        },
      })
      .then((response) => {
        this.vehicles = get(response, 'data.data', []);
      });
    },
    getAssets() {
      this.$store.dispatch("API_CALL", {
        $method: "get_assets",
        $postData: {
          clientid: this.clientid,
        },
      })
      .then((response) => {
        this.assets = get(response, 'data.data', []);
      });
    },
    getAssetTypes() {
      this.$store.dispatch("API_CALL", {
        $method: "get_asset_types",
        $postData: {
          clientid: this.clientid,
        },
      })
      .then((response) => {
        this.assetTypes = get(response, 'data.data', []);
      });
    },
    getUsers() {
        this.$store.dispatch("API_CALL", {
          $method: "get_all",
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          this.users = get(response, 'data.data', []);
        });
    },
    initGantt() {
      // Clear any existing gantt instance
      if (this.gantt) {
        this.gantt.destructor();
        this.gantt = null;
      }
      gantt.clearAll();
      
      gantt.config.scale_unit = "day";
      gantt.config.date_scale = "%d %M";
      gantt.config.subscales = [];
      gantt.config.scale_height = 30;
      gantt.config.min_column_width = 15;
      gantt.config.xml_date = "%Y-%m-%d %H:%i:%s";
      
      gantt.config.auto_scheduling = false;
      gantt.config.auto_scheduling_strict = false;
      gantt.config.auto_scheduling_compatibility = false;
      gantt.config.fit_tasks = false;
      gantt.config.auto_height = false;
      
      gantt.config.row_height = 30;
      gantt.config.grid_width = 300;
      gantt.config.readonly = true;
      
      const indexDays = {
        0: "sunday",
        6: "saturday",
      }

      gantt.templates.scale_cell_class = function(date){
        if(date.getDay() === 0 || date.getDay() === 6){
          return "gantt-weekend" + " " + indexDays[date.getDay()];
        }
        return "";
      };

      gantt.templates.timeline_cell_class = function(item, date){
        if(date.getDay() === 0 || date.getDay() === 6){
          return "gantt-weekend" + " " + indexDays[date.getDay()];
        }
        return "";
      };

      gantt.templates.grid_folder = function(task) {
        if (task.type === "project") {
          return "<span class='mdi mdi-folder' style='margin-right: 5px; margin-left: 5px;'></span>";
        }
        return "<span class='mdi mdi-file' style='margin-right: 5px; margin-left: 5px;'></span>";
      };

      gantt.templates.grid_file = function(task) {
        return "<span class='mdi mdi-calendar-blank' style='margin-right: 10px;'></span>";
      };

      gantt.templates.task_class = function (start, end, task) {
        if (task.type === "project") {
          return "no-bar";
        }
        if (task.color) {
          return "event-bar-" + task.id;
        }
        return "";
      };

      gantt.templates.task_text = function(start, end, task){
        return task.text || "";
      };

      gantt.templates.task_row_class = function(start, end, task) {
        if (task.color) {
          return "event-row-" + task.id;
        }
        return "";
      };

      gantt.init(this.$refs.ganttContainer);

      gantt.config.columns = [
        { name: "text", label: "Asset/Vehicle", tree: true, width: "*" },
        { name: "start_date", label: "Start Date", align: "center", width: 100 },
        { name: "end_date", label: "End Date", align: "center", width: 100 },
        { name: "progress", label: "Progress", align: "center", width: 80 }
      ];

      gantt.attachEvent("onTaskClick", (id, e) => {
        const task = gantt.getTask(id);
        console.log("Task clicked:", task);
        return true;
      });

      gantt.attachEvent("onParse", function(){
        const oldStyles = document.querySelectorAll('style[data-gantt-color]');
        oldStyles.forEach(s => s.remove());
        gantt.eachTask(function(task){
          if (task.color && task.type !== 'project') {
            const style = document.createElement('style');
            style.setAttribute('data-gantt-color', task.id);
            style.innerHTML = `
              .gantt_task_line.event-bar-${task.id} { background-color: ${task.color} !important; border-color: ${task.color} !important; }
              .gantt_row.event-row-${task.id} { background-color: ${task.color}11 !important; }
            `;
            document.head.appendChild(style);
          }
        });
      });

      gantt.attachEvent("onParse", () => {
        gantt.eachTask(function(task) {
          if (task.type === 'project') {
            task.open = true;
          }
        });
        gantt.render();
      });

      gantt.parse({ data: [] });

      this.gantt = gantt;
      
      this.$nextTick(() => {
        this.loadGanttData();
      });
    }
  }
}
</script>

<style>
.gantt-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
}

.gantt-weekend {
  background-color: #f5f5f5 !important;
}

.gantt-weekend.sunday {
  background-color: #ffebee !important;
}

.gantt-weekend.saturday {
  background-color: #e8f5e8 !important;
}
</style>